var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFacebook = function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.349 9A8.28 8.28 0 0 0 9.072.723 8.28 8.28 0 0 0 .795 9c0 4.006 2.847 7.342 6.621 8.111v-5.628H5.761V9h1.655V6.93a2.9 2.9 0 0 1 2.897-2.896h2.07v2.483h-1.656a.83.83 0 0 0-.828.827V9h2.484v2.483H9.899v5.752A8.276 8.276 0 0 0 17.35 9Z",
    fill: "#2360A0"
  })));
};
export default SvgIconFacebook;